import {Component} from "@angular/core";
import {FUIFormContext} from "./form-context";
import {FUIPillFormContext} from "./pill-form-context";

@Component({
    selector: "fui-pill-form-context",
    template: "<ng-content></ng-content>",
    providers: [{provide: FUIFormContext, useClass: FUIPillFormContext}]
})
export class FUIPillFormContextComponent {
}
